export default [
  {
    path: '',
    name: 'home',
    component: () => import('@/views/pages/user/users-list/UsersView.vue'),
    meta: {
      pageTitle: 'My Profile',
      breadcrumb: [
        {
          text: 'My Profile',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
